exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addnotes.active .inner_note{display:none}.inner_note{font-size:14px;color:grey}.inner_note__title{font-weight:700}.slotsLoader span{display:block;margin-bottom:20px}.slotsLoader{display:block;text-align:center;padding:30px 0}.shipp_time_hour{direction:ltr}", ""]);

// exports
